import React from 'react';
import CartItem from './CartItem';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon } from '../Common/Icons';
import { useTheme } from '../Contexts/ThemeContext'; // NEW: Import useTheme

const ShoppingCartSidebar = ({ isOpen, onClose, cartItems, cartTotal, onUpdateQuantity, onRemoveItem }) => {
  const { isDarkMode } = useTheme(); // NEW: Get theme state

  return (
    <>
      <div className={`cart-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
      {/* NEW: Added a conditional 'dark' class */}
      <div className={`cart-sidebar ${isOpen ? 'open' : ''} ${isDarkMode ? 'dark' : ''}`}>
        <div className="cart-header">
          <h2>Your Cart</h2>
          <button onClick={onClose} className="cart-close-button" aria-label="Close Cart">&times;</button>
        </div>
        <div className="cart-body">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <ShoppingCartIcon style={{ width: '48px', height: '48px' }} />
              <h3>Your cart is empty</h3>
              <p>Looks like you haven't added anything yet.</p>
            </div>
          ) : (
            <div>
              {cartItems.map(item => (
                <CartItem
                  key={item.cartItemId}
                  item={item}
                  onUpdateQuantity={onUpdateQuantity}
                  onRemoveItem={onRemoveItem}
                />
              ))}
            </div>
          )}
        </div>
        {cartItems.length > 0 && (
          <div className="cart-footer">
            <div className="cart-subtotal">
              <span>Subtotal</span>
              <span>${cartTotal}</span>
            </div>
            <Link to="/checkout" onClick={onClose}>
              <button className="checkout-button">Proceed to Checkout</button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default ShoppingCartSidebar;